var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 120,
    viewBox: "0 0 116 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.1362 119.833C63.6204 119.833 80.2247 108.688 80.2247 88.2037V29.4482C59.7406 29.4482 43.1362 46.0526 43.1362 66.5368V119.833Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8787 26.1906C21.1109 26.1906 26.9738 20.3277 26.9738 13.0955C26.9738 5.86334 21.1109 0.000488281 13.8787 0.000488281C6.64654 0.000488281 0.783691 5.86334 0.783691 13.0955C0.783691 20.3277 6.64654 26.1906 13.8787 26.1906Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M116 120C98.9667 120 85.1308 106.17 85.1308 89.1303V66.6185C102.164 66.6185 116 80.4479 116 97.4877V120Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.3312 26.2565C74.5634 26.2565 80.4263 20.3936 80.4263 13.1615C80.4263 5.92926 74.5634 0.0664062 67.3312 0.0664062C60.099 0.0664062 54.2362 5.92926 54.2362 13.1615C54.2362 20.3936 60.099 26.2565 67.3312 26.2565Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.8722 119.833C17.3881 119.833 0.783691 108.688 0.783691 88.2037V29.4482C21.2678 29.4482 37.8722 46.0526 37.8722 66.5368V119.833Z",
    fill: "#EFEFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitSvg);
export default __webpack_public_path__ + "static/media/BenefitSvg.fa6f96fbad34ded15847fdebcd7c46fe.svg";
export { ForwardRef as ReactComponent };